var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 12.5C40.5 12.5 12.5 40.5 12.5 75C12.5 109.5 40.5 137.5 75 137.5C109.5 137.5 137.5 109.5 137.5 75C137.5 40.5 109.5 12.5 75 12.5ZM75 125C47.4375 125 25 102.562 25 75C25 47.4375 47.4375 25 75 25C102.562 25 125 47.4375 125 75C125 102.562 102.562 125 75 125Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3125 71.125C87 63.5 85.375 54.625 79.25 48.5C75.9439 45.2102 71.6649 43.0745 67.0485 42.4102C62.4321 41.7459 57.7245 42.5884 53.625 44.8125L68.3125 59.5L59.5 68.3125L44.8125 53.625C40.375 61.875 41.5625 72.3125 48.5 79.25C54.625 85.375 63.5 87 71.125 84.3125L92.4375 105.625C93.6875 106.875 95.625 106.875 96.875 105.625L105.625 96.875C106.875 95.625 106.875 93.6875 105.625 92.4375L84.3125 71.125V71.125Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.2a75e87b.svg";
export { ForwardRef as ReactComponent };